import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { StockInEntity } from "./stock-in.entity";

@Entity('reporting')
export class ReportingEntity {

    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column("int",{
        nullable:true,
        name:"machine_id"
        })
        machineId:number;

    @Column("int",{
        nullable:false,
        name:"model_id"
        })
    modelId:number;

    @Column("int",{
        nullable:false,
        name:"point_type_id"
        })
    pointTypeId:number;

    @Column("int",{
        nullable:false,
        name:"size_id"
        })
    sizeId:number;

    @Column("int",{
        nullable:false,
        name:"stock_id"
        })
    stockId:number;

    @Column('decimal', {
        name: 'quantity',
        nullable: false,
        
    })
    quantity:number;

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length:50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length:50
    })
    updatedUser: string | null;


    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => StockInEntity, stock => stock.reportingData,{nullable:false})
    @JoinColumn({name:'stock_id'})
    reportingInfo: StockInEntity
}
